// frontend/src/components/Registro/RegistroEmpresa.js

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Registro.css';

const ESTADO_INICIAL = {
  nombre_empresa: '',
  rfc: '',
  telefono: '',
  contacto_nombre: '',
  contacto_email: '',
  password: '',
  confirmar_password: '',
  recibe_boletin: true
};

const RegistroEmpresa = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState(ESTADO_INICIAL);
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [registroExitoso, setRegistroExitoso] = useState(false);

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setForm({ ...form, [name]: type === 'checkbox' ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (form.password.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres.');
      return;
    }
    if (form.password !== form.confirmar_password) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    setEnviando(true);
    try {
      const response = await fetch('/api/registro/empresa', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nombre_empresa: form.nombre_empresa,
          rfc: form.rfc,
          telefono: form.telefono,
          contacto_nombre: form.contacto_nombre,
          contacto_email: form.contacto_email,
          password: form.password,
          recibe_boletin: form.recibe_boletin
        })
      });
      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'No se pudo completar el registro.');
        setEnviando(false);
        return;
      }

      setRegistroExitoso(true);
    } catch (err) {
      setError('Error de conexión con el servidor.');
      setEnviando(false);
    }
  };

  if (registroExitoso) {
    return (
      <div className="registro-container">
        <div className="registro-card registro-card-exito">
          <img src="/isotipotransparente.png" alt="" className="registro-icono-exito" />
          <h1>¡Revisa tu correo!</h1>
          <p>
            Enviamos un enlace de verificación a <strong>{form.contacto_email}</strong>.
            Ábrelo para activar tu cuenta y poder iniciar sesión.
          </p>
          <p>🎁 Tu cuenta ya tiene <strong>6 créditos de cortesía</strong> (vigentes por 6 meses) listos para usar en cuanto verifiques tu correo.</p>
          <p className="registro-hint">¿No te llegó? Revisa spam o intenta reenviarlo desde la pantalla de inicio de sesión.</p>
          <Link to="/login" className="btn-registro-primary">Ir a iniciar sesión</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="registro-container">
      <div className="registro-card">
        <img src="/Logotransparente.png" alt="PsyTest" className="registro-logo" />
        <h1>Registra tu empresa</h1>
        <p className="registro-sub">
          Crea tu cuenta gratis y recibe 6 créditos de cortesía (vigencia de 6 meses) para empezar a invitar candidatos
          de inmediato, en cuanto verifiques tu correo.
        </p>

        <form onSubmit={handleSubmit} className="registro-form">
          <div className="registro-field">
            <label>Nombre de la empresa</label>
            <input type="text" name="nombre_empresa" value={form.nombre_empresa} onChange={handleChange} required disabled={enviando} />
          </div>

          <div className="registro-field-row">
            <div className="registro-field">
              <label>RFC</label>
              <input type="text" name="rfc" value={form.rfc} onChange={handleChange} required maxLength="13" disabled={enviando} />
            </div>
            <div className="registro-field">
              <label>Teléfono de contacto</label>
              <input type="tel" name="telefono" value={form.telefono} onChange={handleChange} disabled={enviando} />
            </div>
          </div>

          <div className="registro-field">
            <label>Nombre del contacto</label>
            <input type="text" name="contacto_nombre" value={form.contacto_nombre} onChange={handleChange} required disabled={enviando} />
          </div>

          <div className="registro-field">
            <label>Correo del contacto</label>
            <input type="email" name="contacto_email" value={form.contacto_email} onChange={handleChange} required disabled={enviando} />
          </div>

          <div className="registro-field-row">
            <div className="registro-field">
              <label>Contraseña</label>
              <input type="password" name="password" value={form.password} onChange={handleChange} required minLength="8" disabled={enviando} />
            </div>
            <div className="registro-field">
              <label>Confirmar contraseña</label>
              <input type="password" name="confirmar_password" value={form.confirmar_password} onChange={handleChange} required minLength="8" disabled={enviando} />
            </div>
          </div>

          <label className="registro-check">
            <input type="checkbox" name="recibe_boletin" checked={form.recibe_boletin} onChange={handleChange} disabled={enviando} />
            <span>Quiero recibir actualizaciones de producto, novedades y promociones de PsyTest por correo. Puedo darme de baja en cualquier momento.</span>
          </label>

          {error && <div className="registro-error">{error}</div>}

          <button type="submit" className="btn-registro-primary" disabled={enviando}>
            {enviando ? 'Enviando...' : 'Crear cuenta gratis'}
          </button>
        </form>

        <p className="registro-footer-link">
          ¿Ya tienes cuenta? <Link to="/login">Inicia sesión</Link>
        </p>
        <button type="button" className="registro-volver" onClick={() => navigate('/')}>← Volver al inicio</button>
      </div>
    </div>
  );
};

export default RegistroEmpresa;
